export interface ThemeTokens {
  // Core Palette
  primary: string;
  secondary: string;
  accent: string;
  destructive: string;

  // Backgrounds & Surfaces
  bgPrimary: string;
  bgSecondary: string;
  bgTertiary: string;
  surface: string;

  // Text & Content
  textPrimary: string;
  textSecondary: string;
  textDisabled: string;
  textOnPrimary: string;
  textOnSecondary: string;
  textOnAccent: string;
  textOnDestructive: string;
  textLink: string;
  textHint: string;

  // Borders & Dividers
  border: string;
  divider: string;

  // Interactive Elements
  buttonBg: string;
  buttonText: string;
  buttonHoverBg: string;
  buttonDisabledBg: string;
  buttonDisabledText: string;

  // Specific UI elements (examples, can be expanded)
  headerBg: string;
  headerText: string;
  bottomSheetBg: string;
  sectionHeaderBg: string;
  sectionSeparator: string;
  inputBg: string;
  inputBorder: string;
  inputText: string;
  inputPlaceholder: string;
  modalBg: string;
  modalOverlay: string;
  avatarFallbackBg: string;
  avatarFallbackText: string;
  switchTrack: string;
  switchThumb: string;
  // ... add more as needed based on UI components
}

export const lightTokens: ThemeTokens = {
  // Core Palette
  primary: '#007AFF', // Example: Blue
  secondary: '#5AC8FA', // Example: Light Blue
  accent: '#FF9500', // Example: Orange
  destructive: '#FF3B30', // Example: Red

  // Backgrounds & Surfaces
  bgPrimary: '#FFFFFF', // White
  bgSecondary: '#F2F2F7', // Off-white
  bgTertiary: '#E5E5EA', // Light Gray
  surface: '#FFFFFF', // White (for cards, modals)

  // Text & Content
  textPrimary: '#000000', // Black
  textSecondary: '#3C3C43', // Gray (opacity 60%)
  textDisabled: '#3C3C43', // Gray (opacity 30%)
  textOnPrimary: '#FFFFFF', // White (for text on primary buttons)
  textOnSecondary: '#FFFFFF', // White (for text on secondary buttons)
  textOnAccent: '#FFFFFF', // White
  textOnDestructive: '#FFFFFF', // White
  textLink: '#007AFF', // Blue
  textHint: '#3C3C43', // Gray (opacity 60%)

  // Borders & Dividers
  border: '#C7C7CC', // Light Gray
  divider: '#D1D1D6', // Lighter Gray

  // Interactive Elements
  buttonBg: '#007AFF', // Blue
  buttonText: '#FFFFFF', // White
  buttonHoverBg: '#0056b3', // Darker Blue
  buttonDisabledBg: '#E5E5EA', // Light Gray
  buttonDisabledText: '#3C3C43', // Gray (opacity 30%)

  // Specific UI elements
  headerBg: '#F8F8F8',
  headerText: '#000000',
  bottomSheetBg: '#FFFFFF',
  sectionHeaderBg: '#F2F2F7',
  sectionSeparator: '#D1D1D6',
  inputBg: '#FFFFFF',
  inputBorder: '#C7C7CC',
  inputText: '#000000',
  inputPlaceholder: '#3C3C43', // Gray (opacity 60%)
  modalBg: '#FFFFFF',
  modalOverlay: 'rgba(0, 0, 0, 0.4)',
  avatarFallbackBg: '#E5E5EA',
  avatarFallbackText: '#3C3C43',
  switchTrack: '#E9E9EA',
  switchThumb: '#FFFFFF',
};

export const darkTokens: ThemeTokens = {
  // Core Palette
  primary: '#0A84FF', // Example: Blue (dark mode adjusted)
  secondary: '#64D2FF', // Example: Light Blue (dark mode adjusted)
  accent: '#FF9F0A', // Example: Orange (dark mode adjusted)
  destructive: '#FF453A', // Example: Red (dark mode adjusted)

  // Backgrounds & Surfaces
  bgPrimary: '#111827', // Very Dark (almost black) Blue-Gray
  bgSecondary: '#1F2937', // Dark Slate Gray
  bgTertiary: '#374151', // Cool Gray
  surface: '#1F2937', // Dark Slate Gray - same as new bgSecondary

  // Text & Content
  textPrimary: '#FFFFFF', // White
  textSecondary: '#EBEBF5', // Gray (opacity 60%)
  textDisabled: '#EBEBF5', // Gray (opacity 30%)
  textOnPrimary: '#FFFFFF', // White
  textOnSecondary: '#000000', // Black
  textOnAccent: '#000000', // Black
  textOnDestructive: '#FFFFFF', // White
  textLink: '#0A84FF', // Blue (dark mode)
  textHint: '#EBEBF5', // Gray (opacity 60%)

  // Borders & Dividers
  border: '#4B5563', // Slate Gray (darker)
  divider: '#374151', // Cool Gray (darker)

  // Interactive Elements
  buttonBg: '#0A84FF', // Blue (dark mode)
  buttonText: '#FFFFFF', // White
  buttonHoverBg: '#0060df', // Darker Blue (dark mode)
  buttonDisabledBg: '#374151', // Cool Gray (updated)
  buttonDisabledText: '#EBEBF5', // Gray (opacity 30%)

  // Specific UI elements
  headerBg: '#1F2937', // Dark Slate Gray (updated)
  headerText: '#FFFFFF',
  bottomSheetBg: '#1F2937', // Dark Slate Gray (updated)
  sectionHeaderBg: '#374151', // Cool Gray (updated)
  sectionSeparator: '#4B5563', // Slate Gray (updated)
  inputBg: '#374151', // Cool Gray (updated)
  inputBorder: '#4B5563', // Slate Gray (updated)
  inputText: '#FFFFFF',
  inputPlaceholder: '#EBEBF5', // Gray (opacity 60%)
  modalBg: '#1F2937', // Dark Slate Gray (updated)
  modalOverlay: 'rgba(0, 0, 0, 0.6)',
  avatarFallbackBg: '#374151', // Cool Gray (updated)
  avatarFallbackText: '#EBEBF5',
  switchTrack: '#4B5563', // Slate Gray (updated)
  switchThumb: '#FFFFFF',
}; 